import { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';

export const ezCheckboxThemeConfig: CheckboxDesignTokens = {
  colorScheme: {
    light: {
      root: {
        checkedBackground: '#167007',
        checkedBorderColor: '#167007',
        checkedHoverBackground: '#1C850A',
      },
    },
  },
};
